<era-panel>
  <era-panel-header>
    <era-title>
      <span title
            i18n>Applications</span>

      <era-context-menu [isEditing]="editMode"
                        (selectedEdit)="toggleEditMode()"
                        canEdit="true">
        <button ngbDropdownItem
                (click)="showUploadApplicationModal()">
          <span i18n>Add</span>
        </button>
      </era-context-menu>
    </era-title>
  </era-panel-header>

  <div class="row g-0">
    @for (app of applications | async; track app) {
      <div class="col-sm-12 col-md-12 col-lg-6 col-xl-4 p-2">
        <div class="d-flex bg-gray-100 align-items-center">
          <fa-icon class="mx-4"
                   [icon]="['fab', 'apple']"
                   size="2x"></fa-icon>
          <div class="flex-grow-1 pe-3 py-3 text-truncate">
            <h6 class="mb-1 text-truncate">{{ app.bundleName }}</h6>
            <p class="mb-0 lh-1 text-truncate">
              <small>Version: {{ app.shortVersionString }} ({{ app.bundleVersion }})</small><br />
              <small>Bundle ID: {{ app.bundleIdentifier }}</small>
            </p>
          </div>
          <div class="align-self-stretch"
               [hidden]="!editMode">
            <button class="btn btn-danger h-100"
                    (click)="openRemoveApplicationModal(app)">
              <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    }

    @for (vppApp of vppApplications(); track vppApp) {
      <div class="col-sm-12 col-md-12 col-lg-6 col-xl-4 p-2">
        <div class="d-flex bg-gray-100 align-items-center">
          <fa-icon class="mx-4"
                   [icon]="['fab', 'apple']"
                   size="2x"></fa-icon>
          <div class="flex-grow-1 pe-3 py-3 text-truncate">
            <h6 class="mb-1 text-truncate">{{ vppApp.name }}</h6>
            <p class="mb-0 lh-1 text-truncate">
              <small>Version: {{ vppApp.version }}</small><br />
              <small>Bundle ID: {{ vppApp.bundleId }}</small>
            </p>
          </div>
        </div>
      </div>
    }
  </div>
</era-panel>